import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import { noop } from '@src/utils/common-util';
import $$tracker from '@src/tracker';
class TopMenuStore extends BaseStore {
  @observable getConfigAsync = noop;
  /**
   * 游戏名称
   */
  @observable title;
  /**
   * 游戏副标题
   */
  @observable subTitle;
  /**
   * 游戏图标
   */
  @observable Icon;
  /**
   * 导航列表
   */
  @observable menuList;
  /**
   * 导航状态
   */
  @observable menuState;

  /**
   * 官方媒体状态
   */
  @observable officialListState;

  /**
   * 官网地址
   */
  @observable indexWebUrl;

  @observable state;

  @observable game_stage_config;

  constructor({ title = '剑侠世界4', subTitle = '', Icon, menuList = [], menuState, indexWebUrl, mainStore } = {}) {
    super();
    this.title = title;
    this.subTitle = subTitle;
    this.Icon = Icon;
    this.menuList = menuList;
    this.menuState = menuState;
    this.indexWebUrl = indexWebUrl;
    this.mainStore = mainStore;
  }

  /**
   * 跳转到官网
   */
  @autobind
  onClickMoveToIndex() {
    if (this.indexWebUrl) {
      window.location.href = this.indexWebUrl;
    }
  }
  /** 打开预约弹窗 */
  onReservation = () => {
    if (this.mainStore?.projectConfig?.phone) return;
    $$tracker.clickReservation('顶部通栏');
    this.mainStore?.openOrderTipsModal();
  };
  /**
   * 修改导航状态
   * @param state
   */
  @autobind
  onchangeMenu() {
    this.menuState = !this.menuState;
  }

  use() {
    super.use();
    useMount(() => {});
  }
}
export default TopMenuStore;
